<template>
  <div class="graphic-info-container">
    <el-card>
      <template #header>
        <TitleItem title="图文信息" />
      </template>
      <el-form ref="graphicInfoForm" :model="graphicInfoModel" label-width="125px">
        <el-form-item label="卖点描述">
          <el-row>
            <el-col :span="12">
              <el-input v-model="graphicInfoModel.description" maxlength="30" placeholder="请输入套餐卖点描述(至多30字)"></el-input>
              <p class="desc-tips">用于描述商品售卖亮点、商品优势，商品详情页面标题下方展示</p>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="套餐图片" required>
          <ImageUpload ref="goodsPicRef" :sizeLimit="1" />
          <p class="desc-tips">
            仅支持jpg、png、jpeg文件格式,文件大小建议1M以内,建议尺寸:460像素x460素,至少上传1张图,至多上传10张图,商品图片可展在商品详情页面或视频缩略图
          </p>
        </el-form-item>
        <el-form-item label="套餐视频">
          <VideoUpload ref="goodsVideoRef" />
          <p class="desc-tips">仅支持mp4、webm、ogv格式视频文件,建议视频时间在30s以内,大小不超过50m,至多上传1个视频商品视频可展示在商品详情或商品列表中</p>
        </el-form-item>
        <el-form-item label="套餐详情" required>
          <Tinymce ref="tinymce" id="id" :contentInit="contentInit" />
        </el-form-item>
        <el-form-item label="其他说明">
          <el-row>
            <el-col :span="12">
              <el-input v-model="graphicInfoModel.using" maxlength="30" show-word-limit></el-input>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import Tinymce from "@/components/tinymce";
import TitleItem from "./TitleItem.vue";
import ImageUpload from "./ImageUpload.vue";
import VideoUpload from "./VideoUpload.vue";

const { mapState } = createNamespacedHelpers("publishGoods/publishGoods");
export default {
  components: {
    TitleItem,
    ImageUpload,
    VideoUpload,
    Tinymce,
  },
  data() {
    return {
      prescriptionSet: false, //= true时，展示 是否处方药配置
      graphicInfoModel: {
        description: "", //卖点描述
        desc: "", //"货品属性"
        isPrescription: 0, // 是否处方药 0:否，1:是
        using: "", //其他说明
      },
      contentInit: {},
    };
  },
  computed: {
    ...mapState(["goodsDetail", "shopConfig"]),
  },
  watch: {
    goodsDetail(newVal) {
      this.graphicInfoModel.description = newVal.firstSku.description;
      this.graphicInfoModel.desc = newVal.firstSku.desc;
      this.graphicInfoModel.isPrescription = newVal.firstSku.isPrescription;
      this.graphicInfoModel.using = newVal.firstSku.using;
      this.$refs.tinymce.setMain(newVal.firstSku.attrUrl);
      //货品图片(10张图)
      this.$refs.goodsPicRef.fileList = newVal.firstSku.picList.map((item) => ({ url: item.url }));
      // 视频
      this.$refs.goodsVideoRef.videoUrl = newVal.firstSku.videoUrl;
    },
    shopConfig(newVal) {
      this.prescriptionSet = newVal.prescriptionSet;
    },
  },
  methods: {
    async subMitCheck() {
      if (!this.$refs.goodsPicRef.fileList.length) {
        this.$message.error("请上传套餐图片");
        return;
      }
      if (!this.$refs.tinymce.getMain()) {
        this.$message.error("请填写套餐详情");
        return;
      }

      const graphicInfo = { ...this.graphicInfoModel };
      // 10张图
      graphicInfo.picUrlList = this.$refs.goodsPicRef.fileList.map((item) => item.url);

      // 视频
      if (this.$refs.goodsVideoRef.videoUrl) {
        graphicInfo.videoUrl = this.$refs.goodsVideoRef.videoUrl;
      }

      graphicInfo.attrUrl = this.$refs.tinymce.getMain();

      return graphicInfo;
    },
  },
};
</script>

<style lang="scss" scoped>
.graphic-info-container {
  padding-top: 20px;
  .desc-tips {
    font-size: 12px;
    color: grey;
    line-height: 1.6;
  }
}
</style>
